import { useParams } from 'react-router';

import PrivacyPolicyJa from './ja';
import PrivacyPolicyKo from './ko';
import PrivacyPolicyTh from './th';
import PrivacyPolicyZh from './zh';

const PrivacyPolicy = () => {
  const { language = 'ko' } = useParams();

  if (language === 'th') return <PrivacyPolicyTh />;
  else if (language === 'zh') return <PrivacyPolicyZh />;
  else if (language === 'ja') return <PrivacyPolicyJa />;
  return <PrivacyPolicyKo />;
};

export default PrivacyPolicy;
